<template>
  <div class="main-container">
    <div class="main-header">
      <div class="logo-box">
        <img src="/images/logo.png" alt="">
      </div>
      <div class="name-box">贝利婴幼儿发展量表第四版中文·筛查版2.0统计分析系统</div>
      <topMenu :num="1"></topMenu>
    </div>
    <div class="main-body">
      <div class="left">
        <div class="avt-bg">
          <img src="/images/avt-icon.png" alt="">
        </div>
        <div class="zs-box">
          <div class="zs-box-left" style="width: 100px;">
            <span>主试编号</span>
            <span style="word-break: break-all;">{{ certificate_no }}</span>
          </div>
          <div class="zs-box-right">
            <span>主试姓名</span>
            <span>{{ name }}</span>
          </div>
        </div>
        <div class="num-container">
          <div class="title"><span class="line"></span>可用记分服务数：</div>
          <div class="progress-bars">
            <div class="progress-bar-item">
              <div class="bar-label">
                <span class="bar-age">16天-13个月</span>
                <span class="bar-num">{{ availableNum1 }}份</span>
              </div>
              <div class="bar-track">
                <div class="bar-fill" :style="{ width: (availablePercent1 * 100) + '%' }"></div>
              </div>
            </div>
            <div class="progress-bar-item">
              <div class="bar-label">
                <span class="bar-age">14-24个月</span>
                <span class="bar-num">{{ availableNum2 }}份</span>
              </div>
              <div class="bar-track">
                <div class="bar-fill" :style="{ width: (availablePercent2 * 100) + '%' }"></div>
              </div>
            </div>
            <div class="progress-bar-item">
              <div class="bar-label">
                <span class="bar-age">25-42个月</span>
                <span class="bar-num">{{ availableNum3 }}份</span>
              </div>
              <div class="bar-track">
                <div class="bar-fill" :style="{ width: (availablePercent3 * 100) + '%' }"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="num-container">
          <div class="title" style="margin-top: 20px;"><span class="line"></span>已用记分服务数：</div>
          <div class="progress-bars">
            <div class="progress-bar-item">
              <div class="bar-label">
                <span class="bar-age">16天-13个月</span>
                <span class="bar-num">{{ usedNum1 }}份</span>
              </div>
              <div class="bar-track">
                <div class="bar-fill" :style="{ width: (usedPercent1 * 100) + '%' }"></div>
              </div>
            </div>
            <div class="progress-bar-item">
              <div class="bar-label">
                <span class="bar-age">14-24个月</span>
                <span class="bar-num">{{ usedNum2 }}份</span>
              </div>
              <div class="bar-track">
                <div class="bar-fill" :style="{ width: (usedPercent2 * 100) + '%' }"></div>
              </div>
            </div>
            <div class="progress-bar-item">
              <div class="bar-label">
                <span class="bar-age">25-42个月</span>
                <span class="bar-num">{{ usedNum3 }}份</span>
              </div>
              <div class="bar-track">
                <div class="bar-fill" :style="{ width: (usedPercent3 * 100) + '%' }"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="result-box">
          <div class="result-title">报告结果：</div>
          <div class="result-num"><span>{{ totalNum }}</span> 份</div>
        </div>
        <div class="login-date">上次登录：{{ login_time }}</div>
      </div>
      <div class="right">
        <div class="content" style="margin: 0">
          <div class="header">
            <div class="title-box"><img src="/images/input-header-icon.png" alt=""><span
                class="name">最新提交记分数据列表</span><span class="name" style="font-size: 13px;margin-left: 20px">{{
                currentTime }}</span>
            </div>
          </div>
          <div class="body">
            <div class="search-box">
              <div class="search-form">
                <a-form-model layout="inline" class="search-form" :selfFormModel="true">
                  <a-form-model-item label="诊疗卡号" style="margin-bottom: 10px">
                    <a-input allowClear placeholder="" class="cu-input input-cuw" v-model="page.archives_num" />
                  </a-form-model-item>
                  <a-form-model-item label="姓名" style="margin-bottom: 10px">
                    <a-input allowClear placeholder="" class="cu-input input-cuw" v-model="page.name" />
                  </a-form-model-item>
                  <a-form-model-item label="报告编号" style="margin-bottom: 10px">
                    <a-input allowClear placeholder="" class="cu-input input-cuw" v-model="page.scoring_num" />
                  </a-form-model-item>

                  <a-form-model-item style="margin-bottom: 10px">
                    <a-range-picker style="width:220px" v-model="rang" allowClear @change="changeRangeDate"
                      format="YYYY-MM-DD" />
                  </a-form-model-item>
                  <a-form-model-item style="margin-bottom: 10px">
                    <span class="search-btn" @click="getList()"><img src="/images/search.png" alt=""></span>
                  </a-form-model-item>

                  <a-form-model-item style="margin-bottom: 10px">
                    <span class="search-btn" @click="reset()">重置</span>
                  </a-form-model-item>
                </a-form-model>
              </div>
              <div class="search-add" @click="goBaseData"><span class="add-btn"><img src="/images/add.png"
                    alt=""><span>添加数据</span></span>
              </div>
              <div class="search-add">
                <a-dropdown>
                  <span class="add-btn" style="background: #D08846"><span>导入</span><a-icon type="down" style="margin-left: 5px" /></span>
                  <a-menu slot="overlay">
                    <a-menu-item key="1" @click="downloadTemplate">下载模板</a-menu-item>
                    <a-menu-item key="2">
                      <a-upload
                        :show-upload-list="false"
                        :before-upload="beforeUpload"
                        accept=".xlsx,.xls"
                      >
                        <span>导入上传</span>
                      </a-upload>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </div>
              <div class="search-add">
                <a-button type="primary" :loading="exportLoading" style="height:100%;border-radius:5px;background: #7AB7A5;border-color: #7AB7A5" @click="exportData"><span>导出</span></a-button>
              </div>
            </div>
            <div class="list-box">
              <a-table :columns="columns" :data-source="list" :pagination="false">
                <template slot="edition" slot-scope="text">
                  <span v-if="text == 1">16天-13个月</span>
                  <span v-else-if="text == 2">14-24个月</span>
                  <span v-else-if="text == 3">25-42个月</span>
                  <span v-else>-</span>
                </template>
                <template slot="action" slot-scope="text, record" style="display: flex;align-items: center">
                  <a class="op-box" target="_blank" :href="'http://' + record.down_pdf_url" download="pdf"><img
                      src="/static/download.png" style="width: 20px;height: 20px" alt=""><span>下载</span></a>
                  <span class="de-line"></span>
                  <span v-if="record.is_edit != '2'" class="op-box" @click.stop="goEdit(record, 'index')"><img src="/static/edit.png"
                      style="width: 14px;height: 14px" alt=""><span>编辑</span></span>
                  <span v-if="record.is_edit != '2'" class="de-line"></span>
                  <span class="op-box" @click.stop="openDetail(record)"><img src="/static/eye.png"
                      style="width: 16px;height: 16px" alt=""><span>详情</span></span>
                </template>
              </a-table>
            </div>
            <div class="content-page cu-page"
              style="display: flex;align-items: center;justify-content: flex-end;margin-top: 10px;">
              <a-pagination :hideOnSinglePage="true" v-model="page.start" :page-size.sync="page.pageSize"
                show-quick-jumper :total="page.totalRow" show-less-items @change="changePage" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <detail :item="item" :detailVisible="detailVisible" @detailCancel="detailCancel" />
    <footer-bottom></footer-bottom>
    <bind-list @changeBindList="changeBindList" :id="id" :type="'select'" name="" gender="" born_time="" edition=""
      scoring_type="" :is-visible="bindListVisible"></bind-list>

    <a-modal
      title="导入数据校验失败"
      :visible="showValidationModal"
      :width="800"
      :footer="null"
      @cancel="showValidationModal = false"
    >
      <a-table
        :columns="validationColumns"
        :data-source="validationErrors"
        :pagination="false"
        size="small"
        bordered
      >
        <template slot="errorList" slot-scope="text">
          <span v-for="(err, idx) in text" :key="idx" style="color: #ff4d4f; display: block;">
            {{ err }}
          </span>
        </template>
      </a-table>
    </a-modal>

  </div>
</template>

<script>
import * as Api from './api';
import { GetInfo } from '../../commonApi';
import { message } from "ant-design-vue";
import moment from 'moment';

export default {
  data() {
    return {
      base_url: process.env.VUE_APP_API,
      login_code: window.localStorage.getItem('login_code'),
      labelCol: { span: 8, style: { color: '#7E8589', fontWeight: '500' } },
      wrapperCol: { span: 14 },
      validationErrors: [],
      showValidationModal: false,
      validationColumns: [
        { title: '工作表', dataIndex: 'sheet', key: 'sheet', width: 120 },
        { title: '行号', dataIndex: 'row', key: 'row', width: 80 },
        { title: '错误信息', dataIndex: 'errors', key: 'errors', scopedSlots: { customRender: 'errorList' } }
      ],
      columns: [
        {
          title: '诊疗卡号',
          dataIndex: 'archives_num',
          key: 'archives_num',
          scopedSlots: { customRender: 'archives_num' },
        },
        {
          title: '报告编号',
          dataIndex: 'scoring_num',
          key: 'scoring_num',
          scopedSlots: { customRender: 'scoring_num' },
        },
        {
          title: '儿童姓名',
          dataIndex: 'name',
          key: 'name',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '测试类型',
          dataIndex: 'edition',
          key: 'edition',
          scopedSlots: { customRender: 'edition' },
        },
        {
          title: '测试时间',
          dataIndex: 'test_date',
          key: 'test_date',
          scopedSlots: { customRender: 'test_date' },
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          key: 'create_time',
          scopedSlots: { customRender: 'create_time' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          width: 200
        },
      ],
      rang: null,
      page: {
        start: 1,
        limit: 10,
        totalRow: 0,
        pageSize: 0,
        name: '',
        archives_num: '',
        scoring_num: '',
        edition: undefined,
        isToday: false,
        startTime: '',
        endTime: ''
      },
      list: [],
      name: '',
      certificate_no: '',
      examinerNum: {
        "bayley_simple_num": 0,
        "bayley_complete_num": 0,
        "bayley_screening_num_0_13": 10,
        "bayley_screening_num_14_24": 10,
        "bayley_screening_num_25_42": 10
      },
      usedRecord: {
        "used_bayley_complete_num": 0,
        "used_bayley_simple_num": 0,
        "used_bayley_screening_num_0_13": 2,
        "used_bayley_screening_num_14_24": 3,
        "used_bayley_screening_num_25_42": 1
      },
      login_time: '',
      totalNum: '',
      currentTime: '',
      bindListVisible: false,
      id: '',
      detailVisible: false,
      exportLoading: false,
      item: {}
    };
  },
  computed: {
    progressPercent() {
      const used = this.usedRecord.used_bayley_screening_num;
      const total = this.usedRecord.used_bayley_screening_num + this.examinerNum.bayley_screening_num;
      if (total === 0) return 0;
      return (used / total) * 100;
    },
    availableNum1() {
      return this.examinerNum.bayley_screening_num_1 || 0;
    },
    availableNum2() {
      return this.examinerNum.bayley_screening_num_2 || 0;
    },
    availableNum3() {
      return this.examinerNum.bayley_screening_num_3 || 0;
    },
    usedNum1() {
      return this.usedRecord.bayley_screening_num_1 || 0;
    },
    usedNum2() {
      return this.usedRecord.bayley_screening_num_2 || 0;
    },
    usedNum3() {
      return this.usedRecord.bayley_screening_num_3 || 0;
    },
    availablePercent1() {
      const available = this.availableNum1;
      const total = available + this.usedNum1;
      if (total === 0) return 1;
      return available / total;
    },
    availablePercent2() {
      const available = this.availableNum2;
      const total = available + this.usedNum2;
      if (total === 0) return 1;
      return available / total;
    },
    availablePercent3() {
      const available = this.availableNum3;
      const total = available + this.usedNum3;
      if (total === 0) return 1;
      return available / total;
    },
    usedPercent1() {
      const used = this.usedNum1;
      const total = used + this.availableNum1;
      if (total === 0) return 0;
      return used / total;
    },
    usedPercent2() {
      const used = this.usedNum2;
      const total = used + this.availableNum2;
      if (total === 0) return 0;
      return used / total;
    },
    usedPercent3() {
      const used = this.usedNum3;
      const total = used + this.availableNum3;
      if (total === 0) return 0;
      return used / total;
    }
  },
  mounted() {
    this.getList();
    this.getInfo();

    let start = this.$route.params.start;
    if (start >= 0) {
      this.page.start = start
    }
    let d = moment(new Date(window.localStorage.getItem('login_time'))).format('YYYY-MM-DD HH:mm:ss')
    let c = moment(Date.now()).format('ll')
    this.login_time = d;
    this.currentTime = c + '报表查询';
  },
  methods: {
    goBaseData() {
      this.$router.push({ path: '/base-info' });
    },
    goSelectAge() {
      this.$router.push({ path: '/select-age' })
    },
    async getList() {
      const res = await Api.List(this.page);
      if (res && res.code == 0) {
        this.list = res.page.list;
        this.page.totalRow = res.page.totalRow;
        this.page.pageSize = res.page.pageSize;
      }
    },
    reset() {
      this.page.archives_num = ''
      this.page.name = ''
      this.page.scoring_num = ''
      this.rang = null
      this.page.edition = undefined
      this.page.startTime = '';
      this.page.endTime = '';
      this.getList();
    },
    async getInfo() {
      const res = await GetInfo({});
      if (res && res.code == 0) {
        this.name = res.chiefExaminer.name;
        this.certificate_no = res.chiefExaminer.certificate_no;
        this.examinerNum = res.examinerNum;
        this.usedRecord = res.usedRecord;
        this.totalNum = res.usedRecord.totalBayleyScreening;
      }
    },
    changePage(e) {
      this.page.start = e;
      this.getList();
    },
    openBindList(id) {
      this.bindListVisible = true;
      this.id = id;
    },
    changeBindList(e) {
      if (e.type == 'cancel') {
        this.bindListVisible = false;
      } else if (e.type == 'select') {
        this.bind(e.data.id);
      }
    },
    async bind(id) {
      const res = await Api.Binding({ binding_id: id, id: this.id });
      if (res && res.code == 0) {
        message.success({ content: res.message });
        this.bindListVisible = false;
        this.getList();
      }
    },
    goEdit(record, srouce) {
      // 如果已经编辑过（is_edit == "2"），不执行任何操作
       if (record.is_edit === '2') {
         return;
       }

      // 如果是首次编辑（is_edit == "1"），弹出确认对话框
      if (record.is_edit === '1') {
        this.$confirm({
          title: '提示',
          content: '此报告只能编辑一次，再次编辑将覆盖原有数据，是否确定继续？',
          okText: '确定',
          cancelText: '取消',
          onOk: () => {
            this.$router.push({ path: '/simple', query: { id: record.id, source: srouce, start: this.page.start } })
          }
        });
      } else {
        // 其他情况直接跳转
        this.$router.push({ path: '/simple', query: { id: record.id, source: srouce, start: this.page.start } })
      }
    },
    openDetail(item) {
      this.item = item;
      this.detailVisible = true;
    },
    detailCancel() {
      this.detailVisible = false;
    },
    changeRangeDate(e, s) {
      if (s) {
        this.page.startTime = s[0];
        this.page.endTime = s[1];
      } else {
        this.page.startTime = '';
        this.page.endTime = '';
      }
    },
    formatPercent(percent) {
      return percent.toFixed(2) + '%';
    },
    downloadTemplate() {
      fetch(process.env.VUE_APP_API + '/bayley/screening/report/exportTemplate', {
        headers: {
          'login_code': window.localStorage.getItem('login_code') || ''
        }
      }).then(res => res.json()).then(res => {
        if (res && res.code == 0) {
          let downloadUrl = res.downloadUrl;
          if (downloadUrl && !downloadUrl.startsWith('http://') && !downloadUrl.startsWith('https://')) {
            downloadUrl = 'https://' + downloadUrl;
          }
          window.open(downloadUrl, '_blank');
        } else {
          message.error({ content: res.message || '下载失败' });
        }
      });
    },
    beforeUpload(file) {
      const isExcel = file.type === 'application/vnd.ms-excel' ||
        file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      if (!isExcel) {
        message.error({ content: '只能上传 Excel 文件！' });
        return false;
      }
      const formData = new FormData();
      formData.append('file', file);

      this.loadingMask = true;

      fetch(process.env.VUE_APP_API + '/bayley/screening/report/validateImport', {
        method: 'POST',
        headers: {
          'login_code': window.localStorage.getItem('login_code') || ''
        },
        body: formData
      }).then(res => res.json()).then(res => {
        this.loadingMask = false;
        if (res && res.code == 0) {
          message.success({ content: '校验通过，开始导入...' });
          const formData2 = new FormData();
          formData2.append('file', file);
          Api.ImportData(formData2).then(res2 => {
            if (res2 && res2.code == 0) {
              message.success({ content: res2.message || '导入成功' });
              this.getList();
              this.getInfo();
            } else {
              message.error({ content: res2.message || '导入失败' });
            }
          });
        } else if (res.code == 1 && res.errors) {
          this.validationErrors = res.errors;
          this.showValidationModal = true;
        } else {
          message.error({ content: res.message || '校验失败' });
        }
      }).catch(err => {
        this.loadingMask = false;
        message.error({ content: '校验失败:' + err.message });
      });
      return false;
    },
    exportData() {
      if (this.exportLoading) {
        return
      }
      this.exportLoading = true;
      const exportParams = { ...this.page, start: 1, limit: 99999 };
      const queryString = new URLSearchParams(exportParams).toString();
      fetch(process.env.VUE_APP_API + '/bayley/screening/report/exportData?' + queryString, {
        headers: {
          'login_code': window.localStorage.getItem('login_code') || ''
        }
      }).then(res => res.json()).then(res => {
        this.exportLoading = false;
        if (res && res.code == 0) {
          message.success({ content: '导出成功' });
          let downloadUrl = res.downloadUrl;
          if (downloadUrl && !downloadUrl.startsWith('http://') && !downloadUrl.startsWith('https://')) {
            downloadUrl = 'https://' + downloadUrl;
          }
          window.open(downloadUrl, '_blank');
        } else {
          message.error({ content: res.message || '导出失败' });
        }
      }).catch(() => {
        this.exportLoading = false;
        message.error({ content: '导出失败' });
      });
    },
  }
};
</script>
<style>
.ant-table-thead>tr>th {
  color: #832C75 !important;
  border-top: 2px solid #832C75;
  border-bottom: none;
  background-color: #F2F3F5;
}

.ant-progress-success-bg,
.ant-progress-bg {
  background-color: #832C75;
}

.op-item {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 13px;
  cursor: pointer;
}

a.op-item,
a.op-item:link {
  color: #666666;
}
</style>
<style scoped>
.avt-bg {
  width: 100%;
  height: 100px;
  background-image: url("/images/index-left-avt.png");
  display: flex;
  justify-content: center;
  background-size: contain;
  position: relative;
}

.avt-bg img {
  width: 120px;
  position: absolute;
  top: 10px;
}

.zs-box {
  display: flex;
  border-bottom: 1px solid #F2F3F5;
  padding-bottom: 20px;
  margin-bottom: 20px;
  margin-top: 10px;
}

.zs-box .zs-box-left,
.zs-box .zs-box-right {
  flex: 1;
}

.zs-box .zs-box-right {
  border-left: 1px solid #F2F3F5
}

.zs-box .zs-box-left span,
.zs-box .zs-box-right span {
  font-size: 14px;
  font-weight: 500;
  color: #4A4E51;
  display: block;
  text-align: center;
  line-height: 24px;
}

.main-body {
  background-image: url("/images/maintain-bg.png");
  align-items: flex-start;
  justify-content: flex-start;
}

.left {
  width: 260px;
  background: #FFFFFF;
  box-shadow: 0px 8px 25px 0px rgba(242, 243, 245, 0.28);
  border-radius: 12px;
  padding: 20px;
  height: 100%;
  overflow-y: scroll;
}

.right {
  flex: 1;
  margin-left: 20px;
  height: 100%;
  overflow-y: scroll;
}

.search-box {
  display: flex;
}

.search-box .search-form {
  flex: 1;
}

.search-btn {
  background-color: #D08846 !important;
  padding: 0px 15px !important;
  display: inline-block;
  border-radius: 4px;
  cursor: pointer;
  color: white;
}

.search-btn img {
  width: 14px;
}

.search-add {
  display: inline-flex;
  cursor: pointer;
  margin-left: 10px;
  height: 40px;
}

.search-add:first-child {
  margin-left: 0;
}

.add-btn {
  background: #832C75;
  border-radius: 5px;
  padding: 10px 15px !important;
  display: inline-block;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.add-btn img {
  width: 14px;
  margin-right: 5px;
}

.input-cuw {
  width: 110px;
}

.list-box {
  margin-top: 30px;
}

.title {
  font-size: 14px;
  font-weight: 500;
  color: #4A4E51;
  margin-bottom: 15px;
}

.title .line {
  height: 10px;
  border-left: 3px solid #832C75;
  margin-right: 10px;
}

.num-container {
  border-bottom: 1px solid #F2F3F5;
  padding-bottom: 20px;
}

.num-box {
  margin-bottom: 10px;
  padding-left: 12px;
}

.num-box .name {
  font-size: 12px;
  font-weight: 500;
  color: #86898B;
}

.progress-box {
  display: flex;
}

.progress-box .progress {
  flex: 1;
}

.progress-box .text {
  width: 60px;
  display: flex;
  justify-content: flex-end;
}

.progress-box .text {
  font-size: 12px;
  font-weight: 500;
  color: #86898B;
}

.progress-box .text span.active {
  color: #832C75;
}

.result-box {
  background-color: #F2F3F5;
  font-size: 14px;
  font-weight: 600;
  color: #4A4E51;
  text-align: center;
  padding: 10px 0;
  border-radius: 8px;
}

.result-box .active {
  color: #832C75;
}

.login-date {
  font-size: 13px;
  font-weight: 500;
  color: #7E8589;
  margin-top: 15px;
}

.progress-bars {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.progress-bar-item {
  width: 100%;
}

.bar-label {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
}

.bar-age {
  font-size: 12px;
  color: #86898B;
}

.bar-num {
  font-size: 14px;
  font-weight: 600;
  color: #832C75;
}

.bar-track {
  width: 100%;
  height: 8px;
  background: #E5E6EB;
  border-radius: 4px;
  overflow: hidden;
}

.bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #832C75, #D08846);
  border-radius: 4px;
  transition: width 0.3s ease;
}

.circle-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.circle-age {
  font-size: 10px;
  color: #86898B;
  margin-bottom: 2px;
}

.circle-num {
  font-size: 16px;
  font-weight: 600;
  color: #832C75;
}



.result-box {
  background-color: #F2F3F5;
  padding: 15px;
  border-radius: 8px;
  text-align: center;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.result-title {
  font-size: 14px;
  font-weight: 500;
  color: #4A4E51;
}

.result-num {
  font-size: 14px;
  font-weight: 600;
  color: #4A4E51;
}

.result-num span {
  color: #832C75;
}

.de-line {
  border-right: 1px solid #ddd;
  height: 4px;
  margin: 0 10px;
}

.op-box {
  cursor: pointer;
  color: #666666;
  font-size: 12px;
}

.flex {
  display: flex;
}

.flex-1 {
  flex: 1;
}

.fs {
  justify-content: flex-start;
}

.fe {
  justify-content: flex-end;
}
</style>
